import { DateTime } from 'luxon';

import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility } from '@jms/model';

@Pipe({
  name: 'toDateRelative',
  standalone: true
})
export class ToDateRelativePipe implements PipeTransform {

  transform(value: string | DateTime | Date, timezone?: string, defaultValue = ''): string {

    timezone = timezone || 'UTC';

    if (!value) return (defaultValue);

    const date = DateUtility.getDateTime(value, timezone);
    const now = DateTime.now().setZone(timezone);

    return date.toRelative({ base: now });

  }

}
